import { editCreation } from "./api";

let ask = null; // the mounted <StoryNameChoice/> registers its opener here

export const registerStoryNameChoice = (open) => {
  ask = open;
  return () => { if (ask === open) ask = null; };
};

// Rename a duck. When a hand-edited story still says the old name the server answers 409 (nothing saved); the owner
// then picks "update" / "keep" in the dialog and the rename is re-sent, or cancels (resolves null: nothing changed).
export const renameDuck = async (id, name) => {
  try {
    return await editCreation(id, { name });
  } catch (e) {
    const d = e?.response?.status === 409 ? e.response.data?.detail : null;
    if (d?.code !== "story_name_choice" || !ask) throw e;
    const choice = await ask(d);
    return choice ? editCreation(id, { name, story_text: choice }) : null;
  }
};
